import React, { useContext } from "react";
import Layout from "layouts/LayoutMasterDetail";

import { StoreContext } from "shared/context/store-context";
import EducationYearItem from "./EducationYearItem";

const EducationYearList = () => {
  const itemType = "educationYear";
  const listName = "main_educationYears";

  const { educationYears, InsertEducationYear, DeleteEducationYear, UpdateEducationYear } = useContext(StoreContext);

  const pageItems = educationYears;

  const listColumns = [
    { field: "name", headerName: "Eğitim Öğretim Yılı", width: 300 },
    { field: "yearStartDate", headerName: "Eğitim Başlangıç Tarihi", width: 200 },
    { field: "yearEndingDate", headerName: "Eğitim Bitiş Tarihi", width: 200 },
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={EducationYearItem}
      NewItemComponent={EducationYearItem}
      DeleteItem={DeleteEducationYear}
      InsertItem={InsertEducationYear}
      UpdateItem={UpdateEducationYear}
      hideCreateNewItemWhenSelected={true}
    />
  );
};

export default EducationYearList;
